import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { Flex } from 'antd'
import { isDesktop } from 'react-device-detect'
import { GaleriaCtr } from '../componentes/galeriaCtrl';


const Galeria = (props) => {





    return <Flex vertical align='center' justify='center'>
        <Flex
            gap={10}
            style={{ padding: 25, width: isDesktop ? 1024 : '100%', backgroundColor: 'white' }}
            vertical
            justify='center' >
            <h2> Galeria </h2>

            <GaleriaCtr />
        </Flex>
    </Flex>
}

export default Galeria